<template>
  <div>
    <b-container fluid class="p-0">
      <SlicesBlock v-if="customMerchPage" class="home-padding" :slices="slices" />
      <Merch v-else />
    </b-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import Merch from '@/components/Home/Merch';
import SlicesBlock from '@/components/Prismic/Landings/SlicesBlock.vue';

export default {
  components: {
    Merch,
    SlicesBlock
  },
  async asyncData({ $prismic, store }) {
    try {
      let languages = $prismic.api.data.languages;
      let language = languages.find((item) => item.id.indexOf(store.$i18n.locale) != -1);

      await store.dispatch('config/SEASONAL_STATUS');
      const isSeasonalActive = store.getters['config/isSeasonalActive'];
      const homeUid = isSeasonalActive ? 'merch-home-seasonal' : 'merch-home';

      const result = await $prismic.api.getByUID('post', homeUid, { lang: language.id });

      if (!result) {
        return {
          customMerchPage: false
        };
      }

      return {
        slices: result.data.body,
        customMerchPage: true
      };
    } catch (e) {
      return {
        customMerchPage: false
      };
    }
  },
  computed: {
    ...mapGetters('experience', ['getMerch'])
  },
  created() {
    this.$store.dispatch('dimensions/ACTUAL_DIMENSION', 'All');
  }
};
</script>
